import { throttle, isEmpty } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { BANNER_HEIGHT } from 'components/Banner';
import TopNavigation from 'components/TopNavigation';
import { CAMPAIGN_NAMES } from 'constants/personalizations';
import * as actions from 'state/actions';
import Rudderstack from 'utils/Rudderstack';
import Settings from 'utils/Settings';

const TopNavigationController = class {
  static initNavigation = store => {
    store.dispatch(actions.setTopNavigationData(Settings.topNavigationData));
  };

  static bindCloseTopNavigationOnEscape = store => {
    document.addEventListener(
      'keydown',
      e => {
        if (e.keyCode === 27) {
          store.dispatch(actions.closeTopNavigation());
        }
      },
      false
    );
  };

  static get isPageScrollFrozen() {
    return document.body.style.position === 'fixed';
  }

  static get isBannerVisible() {
    return !TopNavigationController.isPageScrollFrozen && window.pageYOffset <= BANNER_HEIGHT;
  }

  static showBanner = () => {
    document.body.classList.add('Banner--visible');
  };

  static hideBanner = () => {
    document.body.classList.remove('Banner--visible');
  };

  static setBannerVisibility = () => {
    if (TopNavigationController.isBannerVisible) {
      TopNavigationController.showBanner();
    } else {
      TopNavigationController.hideBanner();
    }
  };

  static onScroll = () => {
    window.addEventListener(
      'scroll',
      throttle(() => {
        TopNavigationController.setBannerVisibility();
      }, 100)
    );
  };

  static fetchDyCampaigns = store => {
    store.dispatch(
      actions.fetchPersonalizations({
        names: [
          CAMPAIGN_NAMES.MULTI_TOUCH_CAMPAIGN,
          CAMPAIGN_NAMES.MULTI_TOUCH_RETURNS_MESSAGING,
          CAMPAIGN_NAMES.NAVIGATION_RERUN_RENAMING,
        ],
      })
    );
  };

  static trackNavigationClick({
    navigationType,
    navigationLevel1,
    navigationLevel2,
    navigationLevel3,
    navigationSource,
  }) {
    return Rudderstack.navigationClicked({
      navigationType,
      navigationLevel1,
      navigationLevel2,
      navigationLevel3,
      navigationSource,
    });
  }

  static mountTopNavigationContainer = store => {
    ReactDOM.render(
      <Provider store={store}>
        <TopNavigation
          trackNavigationClick={TopNavigationController.trackNavigationClick}
          miniNavigationProps={TopNavigationController.miniNavigationProps}
        />
      </Provider>,
      document.getElementById('top-navigation-container')
    );
  };

  static init = async store => {
    TopNavigationController.initNavigation(store);
    TopNavigationController.mountTopNavigationContainer(store);
    TopNavigationController.bindCloseTopNavigationOnEscape(store);
    TopNavigationController.fetchDyCampaigns(store);

    if (!isEmpty(Settings.globalBanner)) {
      TopNavigationController.setBannerVisibility();
      TopNavigationController.onScroll();
    }
  };
};

export default TopNavigationController;
